import { Col, Container, Row, ButtonGroup, Dropdown } from "react-bootstrap";
import { LoginForm } from "../components/LoginForm";
import { useTranslation } from "react-i18next";

export const Login = () => {


    const {i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };


  return (
    <Container fluid className="h-90" style={{ height: "100vh", padding: "0", margin: "0" }} >
       <Row>
              <Col xs={6} md={9} className="d-flex justify-content-center" style={{ padding: "0" }}>
                <img
                    src="logo-craiteria.svg"
                    alt="Craiteria"
                    style={{ width: '400px', }}
                      />
              </Col>
              <Col xs={6} md={3} className="d-flex justify-content-end" style={{ padding: "0" }} >
                  <Dropdown as={ButtonGroup}>
                     
                      <Dropdown.Toggle className="border-0" split id="dropdown-split-basic" style={{ background: "#ffffff" }} >
                          <img
                              src="user.svg"
                              alt="Language"
                              style={{ width: '30px', }} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ minWidth: "auto", width: "60px", padding: "0" }}>
                          <Dropdown.Item onClick={() => changeLanguage("ca")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>CA</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeLanguage("en")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>EN</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeLanguage("es")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>ES</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeLanguage("fr")} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>FR</Dropdown.Item>
                      </Dropdown.Menu>
                  </Dropdown>
              </Col>
        </Row>
        <Row>
             <Col md={12} className="d-flex justify-content-center" style={{padding: "0"} }>
               <img
                src="/ilustracio-craiteria-public.png"
                alt="Craiteria"
                style={{ width: '400px', height: '100%', objectFit: 'cover', backgroundColor: '#FFF' }}
                />
            </Col>
        </Row>
        <Row className="mt-3">
            <Col md={12} className="d-flex justify-content-center align-items-center">
               <div className="w-100" style={{ maxWidth: '360px' }}>
                <LoginForm/>
              </div>
            </Col>
        </Row>
    </Container>
  );
}